class ThumbnailData {
  id: string
  url: string;
  title: string;
  mimeType: string;
  isInvoice: boolean;
  isConfidential: boolean;
  constructor(id: string, url: string, title: string, mimeType: string, isInvoice: boolean, isConfidential: boolean) {
    this.id = id;
    this.url = url;
    this.title = title;
    this.mimeType = mimeType;
    this.isInvoice = isInvoice;
    this.isConfidential = isConfidential;
  }
}

export default ThumbnailData;